module.exports = {
  url: 'https://book-store-api-mubaidr.herokuapp.com',
  //url: 'http://localhost:9000',
  books: {
    url: 'https://www.googleapis.com/books/v1/volumes?q='
  }
}



// WEBPACK FOOTER //
// ./src/api.js